import { useDispatch, useSelector } from 'react-redux';

import { startUpgradeProcess } from '@va/dashboard/actions/app';
import { hasUnlimitedVoucher } from '@va/dashboard/selectors/app';
import { isLimitReachedBannerVisible } from '@va/dashboard/selectors/ui';
import { useTranslate } from '@va/localization';
import { hasHigherPremiumPackageToUpgrade } from '@va/standalone/shared/selectors';
import { PreHeaderBadge } from '@va/ui/design-system';

export function LimitReachedBadge() {
  const dispatch = useDispatch();
  const translate = useTranslate();
  const isBannerVisible = useSelector(isLimitReachedBannerVisible);
  const canUpgradeToHigherPlan = useSelector(hasHigherPremiumPackageToUpgrade);

  const hasUnlimitedVoucherApplied = useSelector(hasUnlimitedVoucher);

  if (!isBannerVisible || hasUnlimitedVoucherApplied) return;

  return (
    <PreHeaderBadge
      color='danger'
      message={translate('plan.limitReachedBadge.info')}
      actionText={translate('plan.limitReachedBadge.cta')}
      actionTooltip={!canUpgradeToHigherPlan && translate('tooltips.contributorRole')}
      isActionEnabled={canUpgradeToHigherPlan}
      onActionClick={() => {
        dispatch(startUpgradeProcess());
      }}
    />
  );
}
